"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DialogContent = exports.DialogContainer = void 0;
var _react = require("react");
var _Dialog = require("../components/Dialog");
var _ErrorInfo = require("../components/ErrorInfo");
var _Loading = require("../components/Loading");
var _constants = require("../constants");
var _useTranslations = require("../hooks/useTranslations");
var _getNonDiscontinuedAndCannotBeSold = require("../utils/getNonDiscontinuedAndCannotBeSold");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const DialogContent = exports.DialogContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "ProductInfoDialog_DialogContent" */'./DialogContent')))).DialogContent
}));
const DialogContainer = ({
  analytics = {},
  dialog = {},
  initialProductCode,
  mode = _constants.DIALOG_MODE_LOADING,
  products = [],
  shared = {
    isMrpStatementEnabled: false,
    isRatingsAndReviewsEnabled: false
  },
  replaceSubscription
}) => {
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  const content = (0, _react.useMemo)(() => {
    switch (mode) {
      case _constants.DIALOG_MODE_LOADING:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {});
      case _constants.NOT_FOUND:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorInfo.ErrorInfo, {
          title: translations.productNotFound,
          description: translations.productNotFoundDescription,
          buttonTitle: translations.goBack,
          handleButtonClick: dialog.onClose
        });
      case _constants.DISCONTINUED:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorInfo.ErrorInfo, {
          title: translations.productIsDiscontinued,
          description: translations.productIsDiscontinuedDescription,
          buttonTitle: translations.goBack,
          handleButtonClick: dialog.onClose
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
          fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogContent, {
            analytics: analytics,
            initialProductCode: initialProductCode,
            mode: mode,
            products: (0, _getNonDiscontinuedAndCannotBeSold.getNonDiscontinuedAndCannotBeSold)(products),
            shared: shared,
            replaceSubscription: replaceSubscription
          })
        });
    }
  }, [mode, translations.productNotFound, translations.productNotFoundDescription, translations.goBack, translations.productIsDiscontinued, translations.productIsDiscontinuedDescription, dialog.onClose, analytics, initialProductCode, products, shared, replaceSubscription]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, {
    ...dialog,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
      fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
      children: content
    })
  });
};
exports.DialogContainer = DialogContainer;